export default {
  list: {
    data: null,
    loading: false,
    page: 1,
    perPage: 50,
    total: 0,
    pages: 0,
    error: null
  },
  listReport: {
    data: null,
    loading: false,
    page: 1,
    perPage: 50,
    total: 0,
    pages: 0,
    error: null
  },
  getPublisher: {
    data: null,
    loading: false,
    error: null
  }
}
